export const TIME_FOR_TRANSFORM = 400;
export const TIME_FOR_TRANSFORM_MS = `${TIME_FOR_TRANSFORM}ms`;

export const TIME_FOR_OPACITY = 600;
export const TIME_FOR_OPACITY_MS = `${TIME_FOR_OPACITY}ms`;
